import { render, staticRenderFns } from "./ThirdPartySabaParlayBetContent.vue?vue&type=template&id=b15f9246"
import script from "./ThirdPartySabaParlayBetContent.vue?vue&type=script&lang=js"
export * from "./ThirdPartySabaParlayBetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports